exports.maximumGlobalUsers=10000;